import React from 'react';
import clsx from 'clsx';
import styles from './styles.module.css';
import { IRegionItem } from 'constants/types';

interface RatingItemProps {
  data: IRegionItem;
}

export const RTPItem = ({ data }: RatingItemProps) => {
  const { icon, _id, name, description } = data;

  return (
    <div className={styles.container}>
      <div className={styles.title_description}>
        <div
          className={clsx(
            styles.item_text,
            _id === 'hight' && styles.hight,
            _id === 'average' && styles.average,
            _id === 'low' && styles.low
          )}
        >
          {icon && <div>{icon}</div>}

          {name}
        </div>
        {description && <div className={styles.description}>{description}</div>}
      </div>
    </div>
  );
};
